export default "__VITE_ASSET__DFRgL2gJ__"